import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'

const DEFAULT_MESSAGE = 'You have unsaved changes on this page. Leave without saving?'

/**
 * Asks before unsaved changes are thrown away by leaving the page: following a link or the navigation bar (the
 * router's own navigation), and closing, reloading or leaving the site (the browser's own prompt).
 * Moving between tabs on the same page is not covered; a page with tabs handles that itself.
 */
export function useUnsavedChangesGuard(dirty: boolean, message: string = DEFAULT_MESSAGE) {
  useEffect(() => {
    if (!dirty) return
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [dirty])

  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname)
  useEffect(() => {
    if (blocker.state !== 'blocked') return
    if (window.confirm(message)) blocker.proceed()
    else blocker.reset()
  }, [blocker, message])
}
